import { PrimitiveValidator } from '../validators/PrimitiveValidator.js';
import { BigNumber, MLString, TypeReference } from '../types.js';

export class PrimitiveParser {
  constructor(private primitiveValidator: PrimitiveValidator) {
  }

  parseString(v: any) {
    if (this.primitiveValidator.validString(v)) {
      return v;
    }
  }

  parseMlString(v: any) {
    if (this.primitiveValidator.validMlString(v)) {
      return new MLString(v);
    }
  }

  parseNumber(v: any) {
    if (this.primitiveValidator.validNumber(v)) {
      return v;
    }
  }

  parseBigNumber(v: any) {
    if (this.primitiveValidator.validBigNumber(v)) {
      return new BigNumber(v);
    }
  }

  parseBoolean(v: any) {
    if (this.primitiveValidator.validBoolean(v)) {
      return v;
    }
  }

  parsePrimitive(typeRef: TypeReference, v: any) {
    switch (typeRef) {
      case 'string': {
        return this.parseString(v);
      }
      case 'mlstring': {
        return this.parseMlString(v);
      }
      case 'number': {
        return this.parseNumber(v);
      }
      case 'bignumber': {
        return this.parseBigNumber(v);
      }

      case 'boolean': {
        return this.parseBoolean(v);
      }
      default: {
        throw new Error('Invalid type');
      }
    }
  }
}
